/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {MutableList} from "./MutableList";
import {StreamBankAddItemButton} from "./Buttons/StreamBankAddItemButton";
import {StreamBankRemoveItemButton} from "./Buttons/StreamBankRemoveItemButton";
import {StreamBankRemoveItemRow} from "./StreamBankRemoveItemRow";

export const StreamBankMutableList = (props) => {
    const {
        className,
    } = props;

    return (
        <MutableList
            {...props}
            className={['sb-mutable-list-override-container', className].filter(Boolean).join(' ')}
            itemClassName="sb-mutable-list-item-section col-xs-12"
            AddItemButton={StreamBankAddItemButton}
            RemoveItemRow={StreamBankRemoveItemRow}
            RemoveItemButton={StreamBankRemoveItemButton}
        />
    );
};
